<template>
  <div class="text-container">
    <breadcrumb :list="breadList"></breadcrumb>
    <div class="content-box">
      <div class="title-box">
        <img src="../../assets/image/exam-icon.png" alt="">
        <p class="title">考试安排</p>
      </div>
      <div class="content">
        <div class="test-box">
          <div
            class="test-item"
            v-for="item in testList"
            :key="item.id">
            <p class="title">{{ item.examTitle }}</p>
            <p class="time" v-html="item.examContent"></p>
          </div>
        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageInfo.current"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb'
import { getExamPlanListPage } from '@/api/testPlan'
export default {
  name: 'TeacherList',
  components: {
    Breadcrumb
  },
  data() {
    return {
      testList: [],
      pageInfo: {
        pageSize: 20,
        total: 0,
        current: 1
      },
      breadList: [
        { label: '考试安排', path: '/testPlan' }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    handleSizeChange(val) {
      this.pageInfo.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pageInfo.current = val
      this.getList()
    },
    getList() {
      getExamPlanListPage({
        page: this.pageInfo.current,
        limit: this.pageInfo.pageSize
      }).then(res => {
        const { code, data } = res
        if (code === 0) {
          this.testList = data.records
          this.pageInfo = {
            pageSize: Number(data.size),
            total: Number(data.total),
            current: Number(data.current)
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.text-container {
  width: 1200px;
  margin: 26px auto 0;
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  box-sizing: border-box;
  .breadcrumb {
    width: 100%;
  }
  .content-box {
    width: 1140px;
    padding: 29px 30px;
    .title-box {
      width: 100%;
      height: 55px;
      line-height: 55px;
      padding: 0 30px;
      background: linear-gradient(90deg, #0751B5 0%, #507CF7 100%);
      display: flex;
      flex-direction: row;
      align-items: center;
      box-sizing: border-box;
      margin-bottom: 25px;
      .title {
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        margin-left: 30px;
      }
    }
  }
  .content {
    border: 2px solid #0753B6;
    padding: 15px 47px 45px;
    .test-box {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      .test-item {
        width: 510px;
        height: 107px;
        background-color: #EFEFEF;
        padding: 32px 35px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        box-sizing: border-box;
        margin-top: 30px;
        cursor: pointer;
        .title {
          font-size: 14px;
          font-weight: bold;
          color: #010101;
        }
        .time {
          font-size: 14px;
          color: #000;
          margin-top: 11px;
        }
        &:hover {
          background-color: #085DC8;
          p {
            color: #fff;
          }
        }
      }
    }
    ::v-deep .el-pagination {
      text-align: center;
      margin-top: 50px;
      .el-pagination__total {
        color: #333;
      }
      .el-input__inner, .el-pager li.active {
        color: #333;
        background-color: rgba(10, 101, 219, 0.22);
        border: 1px solid #0753B6;
      }
      .el-pager li.active {
        color: #0753B6;
        border-radius: 5px;
      }
      span {
        color: #333;
      }
    }
  }
}
</style>
